// START IMPORTS
import { useTheme } from '@ltvco/refresh-lib/theme';
import { Security, Message, List, Policy, Radar } from '@mui/icons-material';
// END IMPORTS

// START INTERFACES_AND_TYPES
type DataCounts = {
  commentsLength: number;
};
// END INTERFACES_AND_TYPES

// START HELPER_FUNCTIONS
export const getFraudPhoneNavLinkDataV2 = (DataCounts: DataCounts) => {
  const theme = useTheme();

  return [
    {
      href: '#fraud-phone-overview-section',
      sectionId: '#fraud-phone-overview-section',
      labelText: 'Overview',
      icons: [
        <Security
          key="phone-fraud-overview-icon"
          sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
        />,
      ],
      name: 'phone-fraud-phone-overview-section',
    },
    {
      href: '#threat-detection-section',
      sectionId: '#threat-detection-section',
      labelText: 'Threat Detection',
      hideReportItemsCount: true,
      icons: [<Radar sx={{ color: theme.palette.primary.main }} />],
    },
    {
      href: '#comments-section',
      sectionId: '#comments-section',
      labelText: 'Comments',
      icons: [<Message sx={{ color: theme.palette.primary.main }} />],
      reportItemsCount: DataCounts.commentsLength,
    },
  ];
};

export const getFraudEmailNavLinkDataV2 = () => {
  const theme = useTheme();
  return [
    {
      href: '#fraud-email-overview-section',
      sectionId: '#fraud-email-overview-section',
      labelText: 'Overview',
      icons: [
        <Security
          key="email-fraud-overview-icon"
          sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
        />,
      ],
      name: 'email-fraud-overview-section',
    },
    {
      href: '#additional-details-section',
      sectionId: '#additional-details-section',
      labelText: 'Additional Details',
      icons: [<List sx={{ color: theme.palette.primary.main }} />],
      hideReportItemsCount: true,
    },
  ];
};

export const getFraudIpNavLinkDataV2 = () => {
  const theme = useTheme();
  return [
    {
      href: '#fraud-ip-overview-section',
      sectionId: '#fraud-ip-overview-section',
      labelText: 'Overview',
      icons: [
        <Security
          key="ip-fraud-overview-icon"
          sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
        />,
      ],
      name: 'ip-fraud-overview-section',
    },
    {
      href: '#additional-details-section',
      sectionId: '#additional-details-section',
      labelText: 'Additional Details',
      icons: [<List sx={{ color: theme.palette.primary.main }} />],
      hideReportItemsCount: true,
    },
  ];
};

export const getFraudUrlNavLinkDataV2 = () => {
  const theme = useTheme();
  return [
    {
      href: '#fraud-url-overview-section',
      sectionId: '#fraud-url-overview-section',
      labelText: 'Overview',
      icons: [
        <Security
          key="url-fraud-overview-icon"
          sx={{ color: theme.palette.primary.main, fontSize: '2.5rem' }}
        />,
      ],
      name: 'url-fraud-overview-section',
    },
    {
      href: '#risk-details-section',
      sectionId: '#risk-details-section',
      labelText: 'Risk Details',
      icons: [<Policy sx={{ color: theme.palette.primary.main }} />],
      hideReportItemsCount: true,
    },
    {
      href: '#additional-details-section',
      sectionId: '#additional-details-section',
      labelText: 'Additional Details',
      icons: [<List sx={{ color: theme.palette.primary.main }} />],
      hideReportItemsCount: true,
    },
  ];
};
// END HELPER_FUNCTIONS
